module.exports = __webpack_public_path__ + "static/profile-yvonne-476e520a98d78a8e7c8dc7824f6a1623.jpeg";